import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIALS } from '../data/landing';
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-[2px] ${className}`} aria-hidden="true" data-id="element-188" data-mp="20t9u1ltc6r58">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-gold text-gold" data-id="element-189" data-mp="1r140w8rcm3og" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-cream py-14 md:py-20" aria-labelledby="testimonials-title" data-id="element-190" data-mp="1d0jjnh130fx2">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-191" data-mp="1i28yl7rfddqf">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-192" data-mp="141y4zwyqdl1k">
          <div className="flex items-center justify-center gap-2" data-id="element-193" data-mp="143iz5lh4v1yw">
            <span className="text-[24px] font-extrabold leading-none tracking-[-0.02em] text-ink md:text-[28px]" data-id="element-194" data-mp="1839xqbcwimdz">
              4.9
            </span>
            <Stars data-id="element-195" data-mp="32gixvcjk4vjk" />
            <span className="sr-only" data-id="element-196" data-mp="32h2jb38f222c">4.9 sobre 5</span>
          </div>

          <span className="mt-4 inline-block rounded-full border border-line px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-197" data-mp="2v1koae85lrr0">
            Basado en 500+ hombres
          </span>

          <h2 id="testimonials-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-198" data-mp="34r4b1uyzm5r5">
            Ellos ya empezaron a generar más atracción
          </h2>

          <p className="mx-auto mt-4 max-w-[460px] text-[13px] font-medium leading-relaxed text-ink-muted md:text-[15px]" data-id="element-199" data-mp="2c1x4c8pdq9ut">
            Hombres de distintos países de habla hispana ya usan el Mega Pack
            para mejorar su seguridad, sus conversaciones, sus mensajes y sus
            citas.
          </p>
        </div>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-200" data-mp="2h08d0g3xuebg">
          {TESTIMONIALS.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-[14px] border border-line bg-cream-soft p-5" data-id="element-201" data-mp="1crth63ky6o1">
              <Stars data-id="element-202" data-mp="3dqx6xiiysqd" />
              <blockquote className="mt-3 text-[12px] font-medium leading-relaxed text-ink md:text-[13px]" data-id="element-203" data-mp="3eiqu2skage0">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line/70 pt-4" data-id="element-204" data-mp="ddzxamfn0yb1">
                <img src={testimonial.avatar} alt={`Foto de ${testimonial.name}`} width={160} height={160} loading="lazy" decoding="async" className="h-9 w-9 flex-none rounded-full border border-line object-cover" data-id="element-205" data-mp="ib01sswu9t01" />
                <div className="min-w-0" data-id="element-206" data-mp="3qq0as4ke0axw">
                  <p className="text-[12px] font-bold text-ink" data-id="element-207" data-mp="3vjmm9tete8s4">
                    {testimonial.name}
                  </p>
                  <p className="text-[10px] font-medium text-ink-muted" data-id="element-208" data-mp="2y2xc9cfpo07n">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}